module.exports = __webpack_public_path__ + "assets/img/C2.dae2059e.png";